module.exports = __webpack_public_path__ + "img/04-1-1解决方案.44535eba.png";